import React from 'react';
import { FALLBACK_LANG } from "../utils/intlUtility";
var lang = window.localStorage.getItem('lang') || FALLBACK_LANG;
var preferences;

try {
  var userData = window.localStorage.getItem('guesty_user_data');
  preferences = userData ? JSON.parse(userData).preferences : undefined;
} catch (error) {
  console.error('Error parsing localization preferences from user data', error);
}

export var defaultLocalizationContext = {
  language: lang,
  isEnglish: lang.split('-')[0].toLocaleLowerCase() === 'en',
  preferences: preferences
};
var LocalizationContext = React.createContext(defaultLocalizationContext);
export default LocalizationContext;